module.exports = __webpack_public_path__ + "img/38.ae072c7f.png";